import './AccountTable.css';
import PropTypes from 'prop-types';

const AccountTable = ({ data = [], columns }) => {
  return (
    <div className="AccountTable-wrapper">
      <div className="AccountTable-container">
        <table className="AccountTable">
          <thead>
            <tr className='AccountTable-title'>
              {columns.map((column) => (
                typeof column === 'string' ? (
                  <th key={column} className={`AccountTable-${column.toLowerCase().replace(' ', '-')}`}>{column}</th>
                ) : (
                  <th key="image" className="AccountTable-image">{column}</th>
                )
              ))}
            </tr>
          </thead>
          <tbody>
          {data.map((row) => (
            <tr className='AccountTable-content' key={row.id}>
              {columns.map((column) => (
                <td 
                  key={typeof column === 'string' ? column : 'image'} 
                  className={`AccountTable-${typeof column === 'string' ? column.toLowerCase().replace(' ', '-') : 'image'}-content`}
                >
                  {row[typeof column === 'string' ? column.toLowerCase().replace(' ', '_') : 'image']}
                </td>
              ))}
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

AccountTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      image: PropTypes.string,
    })
  ).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ])
  ).isRequired
};

export default AccountTable;
